import React, { useEffect, useState } from 'react';
import './index.scss';
interface Props {
  onClick: AnyFunc;
  defaultIcon: string;
  hoverIcon: string;
  label: string;
  otherStyles?: React.CSSProperties;
  handleUpdate?: AnyFunc;
}
const OperationBtn = (props: Props) => {
  const { onClick, defaultIcon, hoverIcon, label, otherStyles, } = props;
  const [iconSrc, setIconSrc] = useState(defaultIcon);
  return (
    <>
      <div
        className="operation-btn"
        onClick={(e) => {
          e.stopPropagation();
          onClick();
        }}
        style={otherStyles}
        onMouseEnter={() => {
          setIconSrc(hoverIcon);
        }}
        onMouseLeave={() => {
          setIconSrc(defaultIcon);
        }}
      >
        <img className="operation-icon" src={iconSrc}></img>
        <div className="operation-label">{label}</div>
      </div>
    </>
  );
};
export default React.memo(OperationBtn);
